import React from 'react';
import { TextField } from '@mui/material';
import { useFieldComment } from '../lib/comments';
// TextField that shows the server's message for its field path, or, when there is no error, the reviewer's note on it.
export default function Field({ path, errors, helperText, ...props }) {
  const err = errors && errors[path]; const note = useFieldComment(path);
  const helper = err || (note ? `Reviewer: ${note}` : helperText || ' ');
  return <TextField fullWidth size="small" margin="dense" error={!!err} helperText={helper} FormHelperTextProps={!err && note ? { sx: { color: 'warning.dark', fontWeight: 600 } } : undefined} {...props} />;
}
